// MOCKED placeholder content for the web-studio landing page.
// Branding name, prices, testimonials and stats are placeholders.

export const BRAND = {
  name: "scaleone.cz",
  claim: "Webové studio",
};

export const CITIES = [
  "Prahy",
  "Brna",
  "Ostravy",
  "Plzně",
  "Liberce",
  "Olomouce",
  "Českých Budějovic",
  "Hradce Králové",
  "Ústí nad Labem",
  "Pardubic",
  "Zlína",
  "Havířova",
  "Kladna",
  "Mostu",
  "Opavy",
  "Frýdku-Místku",
  "Karviné",
  "Jihlavy",
  "Teplic",
  "Děčína",
  "Karlových Varů",
  "Jablonce nad Nisou",
  "Mladé Boleslavi",
  "Prostějova",
  "Přerova",
  "České Lípy",
  "Třebíče",
  "Třince",
  "Tábora",
  "Znojma",
  "Příbrami",
  "Kolína",
  "Písku",
  "Trutnova",
  "Kroměříže",
  "Vsetína",
  "Šumperka",
  "Uherského Hradiště",
  "Chebu",
  "Břeclavi",
  "Hodonína",
  "Českého Krumlova",
  "Litoměřic",
  "Havlíčkova Brodu",
  "Strakonic",
  "Kutné Hory",
  "Klatov",
  "Blanska",
  "Náchoda",
  "Žďáru nad Sázavou",
  "Nového Jičína",
  "Chomutova",
  "Krnova",
  "Valašského Meziříčí",
];

export const NAV_LINKS = [
  { label: "Služby", href: "#sluzby" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Ceník", href: "#cenik" },
  { label: "Reference", href: "#reference" },
];

export const MEDIA = {
  heroVideo: "/media/hero.mp4",
  heroVideoWebm: "/media/hero.webm",
  heroPoster: "/media/hero-poster.jpg",
  siteDesktop: "/media/sites/asiatakeover",
  siteMobile: "/media/sites/asiatakeover-mobile",
  siteHost: "asiatakeover.com",
  serviceSite: "/media/sites/pancung",
  serviceHost: "pancung.cz",
};

export const STATS = [
  { value: "40+", label: "dokončených webů, které stále běží" },
  { value: "Skvěle", label: "hodnoceno klienty na Google" },
  { value: "Pod 1 s", label: "průměrné načtení stránky" },
  { value: "21 dní", label: "od zadání po spuštění webu" },
];

export const SERVICES = [
  {
    id: "firemni",
    tag: "Firemní weby",
    title: "Prezentace, které budují důvěru",
    desc: "Web na míru vaší značce — čistý, rychlý a připravený přivádět klienty. Obsah si upravíte sami.",
    kind: "browser",
  },
  {
    id: "eshop",
    tag: "E-shopy",
    title: "Prodávejte online bez třecích ploch",
    desc: "Nákupní proces na tři kliky, platební brány a doprava napojené na váš systém.",
    kind: "checkout",
  },
  {
    id: "landing",
    tag: "Landing pages",
    title: "Kampaně stavěné na konverzi",
    desc: "Jedna stránka, jeden cíl. Měříme, testujeme a zlepšujeme, dokud čísla nerostou.",
    kind: "chart",
  },
  {
    id: "seo",
    tag: "SEO & výkon",
    title: "Rychlost, kterou Google odmění",
    desc: "Technické SEO, Core Web Vitals a obsah, díky kterému vás lidé najdou.",
    kind: "speed",
  },
  {
    id: "udrzba",
    tag: "Péče o web",
    title: "Postaráme se o web i po spuštění",
    desc: "Aktualizace, zálohy, monitoring dostupnosti a rychlá podpora, když je potřeba.",
    kind: "status",
  },
];

export const PROCESS = [
  { num: "01", title: "Poznáme se", desc: "Zjistíme, co potřebujete, komu prodáváte a jak vypadá úspěch. Bez zbytečných frází." },
  { num: "02", title: "Návrh & design", desc: "Vytvoříme vizuální koncept a klikací prototyp, který si osaháte ještě před vývojem." },
  { num: "03", title: "Vývoj", desc: "Kódujeme rychlý, responzivní a bezpečný web s pečlivostí v každém pixelu." },
  { num: "04", title: "Spuštění & růst", desc: "Nasadíme web, změříme výsledky a pomáháme mu růst i po startu." },
];

export const PROJECTS = [
  {
    id: "onebigparty",
    name: "One Big Party",
    category: "Event web",
    year: "2026",
    url: "https://onebigparty.net",
    host: "onebigparty.net",
    media: "/media/sites/onebigparty",
    desc: "Zábavný a energický web pro párty a akce, plný pohybu.",
    span: "md:col-span-2",
  },
  {
    id: "pancung",
    name: "Pan Čung Radí",
    category: "Firemní web",
    year: "2026",
    url: "https://pancung.cz",
    host: "pancung.cz",
    media: "/media/sites/pancung",
    desc: "Finanční kalkulačky a poradenství v přehledné, důvěryhodné prezentaci.",
    span: "md:col-span-2",
  },
  {
    id: "asiatakeover",
    name: "Asia Takeover",
    category: "Event web",
    year: "2026",
    url: "https://asiatakeover.com",
    host: "asiatakeover.com",
    media: "/media/sites/asiatakeover",
    desc: "Výrazný web pro událost s energickým vizuálem a jasným CTA.",
    span: "md:col-span-2",
  },
];

export const PRICING_BUILD = {
  eyebrow: "Tvorba webu — jednorázově",
  title: "Vyberte řešení pro váš business",
  subtitle: "Od profesionálního firemního webu až po komplexní řešení na míru.",
  plans: [
    {
      id: "standard",
      name: "Standard",
      price: "19 900 Kč",
      priceNote: "Jednorázově",
      desc: "Ideální pro živnostníky a menší firmy, které potřebují moderní a profesionální online prezentaci.",
      features: [
        "Až 5 podstránek",
        "Moderní design na míru",
        "Responzivní design pro mobil, tablet a desktop",
        "Kontaktní formulář",
        "Základní animace a interakce",
        "Základní on-page SEO",
        "SEO title a meta description",
        "Optimalizace obrázků a rychlosti webu",
        "Google Analytics 4",
        "Google Search Console",
        "Napojení sociálních sítí",
        "SSL zabezpečení",
        "2 kola revizí před spuštěním",
        "Nasazení webu na vlastní doménu",
      ],
      cta: "Vybrat Standard",
      prefill: "Mám zájem o balíček Standard – 19 900 Kč.",
      highlighted: false,
    },
    {
      id: "business",
      name: "Business",
      badge: "Nejoblíbenější",
      price: "39 900 Kč",
      priceNote: "Jednorázově",
      desc: "Pro firmy, které chtějí profesionální web zaměřený nejen na prezentaci značky, ale také na získávání zákazníků.",
      features: [
        "Vše ze Standard",
        "Až 12 podstránek",
        "Pokročilý individuální design",
        "Pokročilé animace a interakce",
        "Pokročilejší SEO struktura webu",
        "Analýza relevantních klíčových slov",
        "Optimalizace struktury pro konverze",
        "Pokročilé kontaktní a poptávkové formuláře",
        "Google Analytics 4",
        "Google Search Console",
        "Meta Pixel",
        "Conversion tracking",
        "CMS / blog podle potřeby",
        "Základní integrace externí služby",
        "Příprava webu pro Google Ads a Meta Ads",
        "4 kola revizí před spuštěním",
        "Prioritní realizace",
      ],
      cta: "Vybrat Business",
      prefill: "Mám zájem o balíček Business – 39 900 Kč.",
      highlighted: true,
    },
    {
      id: "individual",
      name: "Individual",
      price: "Cena na míru",
      priceNote: "",
      desc: "Pro e-shopy, webové aplikace a projekty, které vyžadují individuální funkce nebo rozsáhlejší řešení.",
      features: [
        "Individuální počet stránek",
        "E-commerce / e-shop",
        "Online platby",
        "Rezervační systémy",
        "Uživatelské účty a klientské zóny",
        "Databázové funkce",
        "Pokročilé formuláře",
        "API integrace",
        "Integrace externích systémů",
        "Automatizace",
        "Vícejazyčné weby",
        "Pokročilá analytika a tracking",
        "Individuální SEO řešení",
        "Individuální funkce podle projektu",
      ],
      note: "Po krátké konzultaci připravíme rozsah projektu a individuální cenovou nabídku.",
      cta: "Poptat individuální řešení",
      prefill: "Mám zájem o individuální řešení.",
      highlighted: false,
    },
  ],
};

export const PRICING_CARE = {
  eyebrow: "Správa a provoz — měsíčně",
  title: "Postaráme se o váš web i po spuštění",
  subtitle: "Vyberte si úroveň správy podle toho, kolik péče a dalšího rozvoje váš web potřebuje.",
  plans: [
    {
      id: "basic",
      name: "Basic",
      price: "990 Kč",
      priceNote: "/ měsíc",
      desc: "Spolehlivý provoz webu bez starostí.",
      features: [
        "Hosting a provoz webu",
        "SSL zabezpečení",
        "Monitoring dostupnosti",
        "Technická údržba",
        "Základní technická podpora",
        "Průběžná kontrola funkčnosti",
      ],
      note: "Obsahové změny a nové funkce jsou účtovány samostatně.",
      cta: "Vybrat Basic",
      prefill: "Mám zájem o balíček Basic – 990 Kč / měsíc.",
      highlighted: false,
    },
    {
      id: "care",
      name: "Care",
      badge: "Doporučujeme",
      price: "1 990 Kč",
      priceNote: "/ měsíc",
      desc: "Pro firmy, které chtějí mít web pravidelně aktualizovaný a technicky pod kontrolou.",
      features: [
        "Vše z Basic",
        "Prioritní technická podpora",
        "Drobné úpravy webu v ceně",
        "Až 30 minut úprav měsíčně",
        "Aktualizace textů",
        "Výměna obrázků",
        "Úpravy kontaktních údajů a dalšího obsahu",
        "Kontrola Google Analytics",
        "Kontrola funkčnosti formulářů",
        "Pravidelná kontrola webu",
      ],
      note: "Nevyužitý čas na úpravy se nepřevádí do dalšího měsíce. Rozsáhlejší změny a nové funkce jsou naceněny samostatně.",
      cta: "Vybrat Care",
      prefill: "Mám zájem o balíček Care – 1 990 Kč / měsíc.",
      highlighted: true,
    },
    {
      id: "growth",
      name: "Growth",
      price: "3 490 Kč",
      priceNote: "/ měsíc",
      desc: "Pro firmy, které chtějí svůj web dlouhodobě zlepšovat a využívat ho jako nástroj pro růst.",
      features: [
        "Vše z Care",
        "Až 2 hodiny úprav a optimalizací měsíčně",
        "Průběžná SEO optimalizace",
        "Technické SEO kontroly",
        "Google Search Console monitoring",
        "Google Analytics monitoring",
        "Sledování výkonu webu",
        "Optimalizace landing pages",
        "Optimalizace konverzních prvků",
        "Návrhy na další zlepšení webu",
        "Měsíční report",
      ],
      note: "Správa reklam Google Ads a Meta Ads ani reklamní rozpočet nejsou součástí tohoto balíčku.",
      cta: "Vybrat Growth",
      prefill: "Mám zájem o balíček Growth – 3 490 Kč / měsíc.",
      highlighted: false,
    },
  ],
};

export const TESTIMONIALS = [
  {
    name: "Martin Nguyen",
    role: "WINORWINS — Clothing Brand",
    since: "Klient od 2026",
    avatar: "/media/avatars/martin.jpg",
    text: "Nový web nám během tří měsíců zdvojnásobil počet objednávek. Spolupráce byla rychlá a naprosto bez stresu.",
  },
  {
    name: "Andrej Nguyen",
    role: "ASIATAKEOVER",
    since: "Klient od 2026",
    avatar: "/media/avatars/andrej.jpg",
    text: "Konečně web, za který se nestydím. Vypadá skvěle na mobilu i na počítači a zákazníci to poznají.",
  },
  {
    name: "Pan Čung",
    role: "Finance jednoduše",
    since: "Klient od 2026",
    avatar: "/media/avatars/pancung.jpg",
    text: "Skvělý cit pro detail. Animace a přechody dávají webu úplně jinou úroveň, než na jakou jsem byl zvyklí.",
  },
];

export const FAQ = [
  {
    q: "Kolik stojí nový web?",
    a: "Jednostránkový web startuje na 19 900 Kč, běžný firemní web se pohybuje mezi 45–90 tisíci a e-shopy počítáme individuálně. Cenu vždy potvrdíme předem — žádné dodatečné položky.",
  },
  {
    q: "Jak dlouho trvá, než web spustíme?",
    a: "Landing page zvládneme za 7–10 dní, firemní web typicky za 3 týdny od schválení návrhu. E-shopy a větší projekty 6–10 týdnů podle rozsahu.",
  },
  {
    q: "Budu si moci obsah upravovat sám?",
    a: "Ano. Weby napojujeme na jednoduchou administraci, kde měníte texty, obrázky i celé sekce bez znalosti kódu. Předáme vám i krátké video zaškolení.",
  },
  {
    q: "Řešíte i doménu, hosting a e-maily?",
    a: "Zajistíme vše — doménu, rychlý hosting, firemní e-maily, SSL certifikát i zálohy. Stačí říct a nemusíte se o technikálie starat vůbec.",
  },
  {
    q: "Co když už web mám a jen ho potřebuji oživit?",
    a: "Uděláme UX audit, navrhneme nový vizuál a web přestavíme bez ztráty pozic ve vyhledávání. Přesměrování a SEO řešíme jako standardní součást redesignu.",
  },
  {
    q: "Pomůžete i po spuštění webu?",
    a: "Ano, nabízíme měsíční péči: aktualizace, zálohy, monitoring dostupnosti, drobné úpravy a reporty výkonu. Kdykoli lze i jednorázově.",
  },
];

export const CONTACT = {
  email: "info@scaleone.cz",
  phone: "+420 776 622 955",
  location: "Praha, Česká republika",
};
